import React, { useEffect, useRef, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { LogoContext } from '../contexts/LogoContext';
import { AppBar, Toolbar, Box, Button, Slide, IconButton, Tooltip } from '@mui/material';
import HeaderSearchForm from './HeaderSearchForm';
import MenuIcon from '@mui/icons-material/Menu';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const Header = ({ isAuth, logout, login, headerShow, setHeaderShow, onMenuClick }) => {
  const { logoUrl, companyName } = useContext(LogoContext);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      const diff = currentY - lastScrollY.current;

      if (diff < -5) setHeaderShow(true);
      else if (diff > 5) setHeaderShow(false);

      lastScrollY.current = currentY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Slide appear={false} direction="down" in={headerShow} timeout={{ enter: 500, exit: 100 }}>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          bgcolor: '#ffffff',
          color: 'text.primary',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          borderTop: (theme) => `solid 8px ${theme.palette.primary.main}`,
          borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
        }}
      >

        <Toolbar >
          <IconButton
            color="inherit"
            edge="start"
            onClick={onMenuClick}
          //sx={{ display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          {/* ロゴ */}
          <Box component={RouterLink} to="/" sx={{ display: 'flex', alignItems: 'center' }}>
            <Box
              component="img"
              src={logoUrl
                ? `${process.env.REACT_APP_IMAGE_BASE_URL}${logoUrl}`
                : `${process.env.REACT_APP_IMAGE_BASE_URL}${process.env.REACT_APP_LOGO}`
              }
              alt={companyName || 'ロゴ'}
              sx={{ maxWidth: '100%', maxHeight: 70 }}
            />
          </Box>
          <Box
            sx={{
              flex: 1,
              mx: 2,
              display: { xs: 'none', md: 'flex' },
            }}
          >
            <HeaderSearchForm />
          </Box>
          <Box sx={{ flexGrow: 1, display: { md: 'none' } }} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Tooltip title='カート'>
              <IconButton
                component={Link}
                to="/cart"
                color="inherit"
                aria-label="カート"
              >
                <ShoppingCartIcon />
              </IconButton>
            </Tooltip>
            {isAuth ? (
              <Tooltip title='ログアウト'>
                <IconButton color="inherit" onClick={logout} aria-label="ログアウト">
                  <LogoutIcon />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title='ログイン'>
                <IconButton
                  color="inherit"
                  onClick={login}
                  aria-label="ログイン">
                  <LoginIcon />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        </Toolbar>
        <Box
          sx={{
            display: { xs: 'block', md: 'none' },
            px: 2,
            pb: 1,
          }}
        >
          <HeaderSearchForm />
        </Box>
      </AppBar>
    </Slide >
  );
};

export default Header;
